(function () {
    const translations = {
      "incadeworld.com": {
        "Тип кейсу": "Case type",
        "Колір телефону": "Phone color"
      },
      "pl.incadeworld.com": {
        "Тип кейсу": "Typ etui",
        "Колір телефону": "Kolor telefonu"
      }
    };
    
    const currentHost = window.location.hostname;
    const dict = translations[currentHost];
    console.log(currentHost, dict);
    if (dict) {
      document.querySelectorAll("tr .tt-title p").forEach(p => {
        let html = p.innerHTML;
        Object.keys(dict).forEach(uaText => {
          const translated = dict[uaText];
          html = html.replace(uaText, translated);
        });
        p.innerHTML = html;
      });
    }
    
  })();